<script setup lang="ts">
import './assets/style.scss'
import { VModal, VPreloader } from '@/shared/ui'
import { useEventsNotification } from './../model/model'
import { UserAlerts } from '@/features/User/UserAlerts'
import { watch, watchEffect } from 'vue'
import { useHelpers, useSseConnection, statusDateToClientLocal } from '@/shared/lib'
import { useAuth } from '@/entities/Auth'
import { useRoute, useRouter } from 'vue-router'

const model = useEventsNotification()
const auth = useAuth()
const route = useRoute()
const router = useRouter()

const { refetch, isLoading } = model.loadData()
const { toTimeFormat, toTime } = useHelpers()

const getPassportV2Link = (item: any): string => {
  const raw = String(item?.link || '')
  const match = raw.match(/\/inventory\/objects\/(\d+)/)
  const inventObjectId = Number(match?.[1])
  if (!inventObjectId) return raw

  const routeObjectId = Number(route.params.object_id)
  const groupObjectId = routeObjectId || Number(auth.user?.object_group?.id) || 1
  const objectType = String(route.params.type || 'groups')

  return router.resolve({
    name: 'object.inventory.elements.passport-v2',
    params: {
      type: objectType,
      object_id: groupObjectId,
      tab: 'inventory',
      tab_inventory: 'elements',
      invent_object_id: inventObjectId,
    },
  }).href
}

const formatDeliveryTime = (value: string) => {
  if (!value) return ''
  const local = statusDateToClientLocal(value)
  if (local.isValid) return local.toFormat('dd.MM.yyyy HH:mm:ss')
  return toTimeFormat(toTime(value).toISO() || value, 'dd.MM.yyyy HH:mm:ss')
}

/** Запрашиваем данные при открытии */
watchEffect(() => {
  if (model.open) refetch()
})

/* Устанавливаем SSE соединение */
const { handler } = useSseConnection((res: any) => {
  if (model.open) {
    refetch()
  } else {
    model.isNew = true
  }
})

watch(
  () => auth.user,
  () => {
    if (auth.user) {
      handler(`/notifications/stream/${auth.user.user_id}`)
    }
  },
  { immediate: true },
)
</script>

<template>
  <VModal title="Последние события" v-model.show="model.open" :width="600">
    <UserAlerts />

    <div class="event-last__table">
      <VPreloader v-if="isLoading" :wrapper-height="100" />
      <VTable v-else density="comfortable">
        <thead>
          <tr>
            <th>{{ $t('itf.time') }}</th>
            <th>{{ $t('itf.object') }}</th>
            <th>{{ $t('itf.event') }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="model.data.length">
            <tr v-for="item in model.data">
              <td>
                {{
                  item.created_at
                    ? formatDeliveryTime(item.created_at)
                    : $t('itf.not_info')
                }}
              </td>
              <td>
                <a v-if="item.link" :href="getPassportV2Link(item)">{{ item.title }}</a>
                <span v-else>{{ item.title }}</span>
              </td>
              <td>{{ item.body || '-' }}</td>
            </tr>
          </template>

          <tr class="event-last__empty" v-else>
            <td colspan="3">{{ $t('itf.not_info') }}</td>
          </tr>
        </tbody>
      </VTable>
    </div>

    <div class="mt-2 form__btn_right">
      <VBtn color="default" @click="model.closeModal">{{ $t('itf.close') }}</VBtn>
    </div>
  </VModal>
</template>
